<template lang="pug">
section
  s-page-title(
    :previous='true'
    :backName='(item.complex ? item.complex.complex_full_name : null)'
    :title='objectId ? "Редактирование объекта" : "Добавление объекта"'
    :subtitle='(item.complex ? item.complex.complex_full_name : "") + (item.object_name ? ", " + item.object_name : "") '
  )
  v-card
    v-tabs(v-model='active' color='dark' slider-color='primary')
      v-tab Объект
      v-tab-item(:transition='false' :reverse-transition='false')
        v-container(grid-list-xl fluid)
          v-layout(wrap)
            v-flex(xs12)
              s-publish-date-status(
                :errors='errors'
                :model='item',
                label="Открыть в МП и на Корп сайте"
              )
            v-flex(xs12 sm6)
              v-checkbox(
                v-model='item.authorized_only'
                label='Только для авторизованных'
                color='primary'
              )
            v-flex(xs12 sm6)
              v-checkbox(
                v-model='item.internal_managers_only'
                label='Только для менеджеров Унистроя'
                color='primary'
              )              
            v-flex(xs12)
              v-slider(
                v-model='item.progress'
                :error='errors.has("progress")'
                :error-messages='errors.first("progress")'
                label="Процент завершения"
                persistent-hint
                step="1"
                thumb-label="always")
            v-flex(xs12 sm4)
              s-date-picker(
                :validator='errors'
                v-model='item.due_date'
                label='Срок передачи'
                name='due_date'
              )
            v-flex(xs12 sm4)
              s-date-picker(
                :validator='errors'
                v-model='item.inspection_opened'
                label='Открыть запись на осмотр с:'
                name='inspection_opened'
              )
            v-flex(xs12 sm4)
              v-text-field(
                :error='errors.has("inspection_opened_in_sections")'
                :error-messages='errors.first("inspection_opened_in_sections")'
                v-model='item.inspection_opened_in_sections'
                label='В указнных подъездах:'
              )
            v-flex(xs12 sm3)
              v-checkbox(
                v-model='item.has_remont'
                label='Есть чистовая отделка'
                color='primary'
              )
            v-flex(xs12 sm3)
              v-checkbox(
                v-model='item.is_start'
                label='Метка "Старт продаж"'
                color='primary'
              )
            v-flex(xs12 sm3)
              s-object-steps-picker(
                :error='errors.has("state_id")'
                :errors-messages='errors.first("state_id")'
                v-model='item.state_id'
              )
            v-flex(xs12 sm3)
              s-object-statuses-picker(
                :error='errors.has("status_id")'
                :errors-messages='errors.first("status_id")'
                v-model='item.status_id'
              )
            v-flex(xs12 sm3)
              v-text-field(
                :error='errors.has("object_name")'
                :error-messages='errors.first("object_name")'
                v-model='item.object_name'
                label='Название строения'
              )
            v-flex(xs12 sm3)
              v-text-field(
                :error='errors.has("building_number")'
                :error-messages='errors.first("building_number")'
                v-model='item.building_number'
                label='Строительный номер'
              )
            v-flex(xs12 sm3)
              s-object-types-picker(
                :error='errors.has("object_type_id")'
                :errors-messages='errors.first("object_type_id")'
                v-model='item.object_type_id'
              )
            v-flex(xs12 sm3)
              v-text-field(
                :error='errors.has("fact_number")'
                :error-messages='errors.first("fact_number")'
                v-model='item.fact_number'
                label='Фактический номер'
              )
            v-flex(xs12, sm6)
              v-text-field(
                v-model='item.dvizh_uuid',
                label='UUID доиа в ДВИЖ'
              )
            v-flex(xs12 sm6 )
              v-select(
                :items='managementCompList'
                label='Управляющая компания'
                item-value='id'
                item-text='name'
                v-model='item.management_company_id'
              )
            v-flex(xs12)
              v-text-field(
                :error='errors.has("address")'
                :error-messages='errors.first("address")'
                v-model='item.address'
                label='Адрес'
              )
            v-flex(xs12)
              s-coordinates-picker(
                :lat.sync='item.lat'
                :lon.sync='item.lon'
                ref='coordinatesPicker'
                @change='onGeographyChange'
              )
            v-flex(xs12 sm4)
              s-image-upload(
                :src='item.avatar_url'
                @remove='onRemoveAvatar'
                v-model='item.avatar'
                label='Фото объекта'
              )
            v-flex(xs12 sm4)
              s-image-upload(
                :editor='true'
                :src='item.object_scheme_url'
                @remove='onRemoveScheme'
                @editor='editorOpened=true'
                v-model='item.scheme'
                label='Схема объекта'
              )
      v-tab Настройки
      v-tab-item(:transition='false' :reverse-transition='false')
        v-container(grid-list-xl fluid)
          v-toolbar(flat color='white')
            h3(class='title') Связанные объекты из 1С
            v-spacer
            v-btn(@click='openLinkGuidDialog' small flat)
              v-icon(left small) add
              | Добавить объект
          v-divider
          v-data-table(
            :hide-actions='true'
            :items='extGuids'
            :headers=`[
              { text: "#ID", sortable: false, width: '0%' },
              { text: "Название в 1С", width: '30%', sortable: false },
              { text: "GUID", sortable: false, align: "center" },
              { text: "Тип помещений", sortable: false, align: "center" },
              { text: "Секция", sortable: false, align: "center" },
              { text: "Имя файла импорта", sortable: false, align: "center" },
            ]`
          )
            template(slot='items' slot-scope='props')
              tr(class='with-pointer')
                td {{ props.item.pivot.id }}
                td(class='') {{ props.item.name }}
                td(class='') {{ props.item.pivot.ext_guid }}
                td(class='') {{ props.item.pivot.ext_object_type_id }}
                td(class='') {{ props.item.pivot.selected_sections }}
                td(class='')
                    div {{ props.item.pivot.import_file_name }}
                    div {{ props.item.pivot.last_import_time }}
                td(class='text-xs-right wrapless crud-tools')
                  v-btn(icon @click='onDeleteGuidLink(props.item.pivot)')
                    v-icon(small) delete_outline
      v-tab Генплан
      v-tab-item(:transition='false' :reverse-transition='false')
        v-container(grid-list-xl fluid)
          v-layout(wrap)
            v-flex(xs12)
              v-text-field(
                :error='errors.has("path_scheme")'
                :error-messages='errors.first("path_scheme")'
                v-model='item.path_scheme'
                label='Путь обводки на генплане'
                disabled=true
              )
            v-flex(xs12)
              v-text-field(
                :error='errors.has("mark_scheme")'
                :error-messages='errors.first("mark_scheme")'
                v-model='item.mark_scheme'
                label='Метка дома на генплане'
                disabled=true
              )
          v-data-table(
            :hide-actions='true'
            :items='genplan.objects'
            :headers=`[
              { text: "#ID", sortable: false, width: '0%' },
              { text: "Название", sortable: false },
              { text: "Метка", sortable: false, align: "center" },
              { text: "Обводка", sortable: false, align: "center" },
              { text: "", width: "100%", sortable: false },
              { text: "", width: "0%", sortable: false }
            ]`
          )
            template(slot='items' slot-scope='props')
              tr(class='with-pointer' @click='genplan.opened = true')
                td {{ props.item.id }}
                td(class='wrapless') {{ props.item.name }}
                td(class="center")
                  v-icon(v-if='props.item.point' color='primary') done
                td(class="center")
                  v-icon(v-if='props.item.polygon' color='primary') done
                //- распорка, не ну а чо )
                td
                td(class='text-xs-right wrapless crud-tools')
                  v-btn(icon @click.stop='genplan.opened = true')
                    v-icon(small) edit
                  s-publish-status-toggle(
                    :value='props.item'
                    @success='props.item.published  = !props.item.published '
                    resource='complexes/objects/paths'
                  )
          //- Редактор генплана
          genplan-modal(v-model='genplan' @complete='saveGenplan')
          v-divider
    v-card-actions(v-if='actionsShown' class='large')
      v-spacer
      s-back-btn
      v-btn(
        :loading='isLoading'
        @click.native='onSave'
        color='primary'
        depressed
      ) Сохранить
  modal-editor(
    v-model='editorOpened'
    :source='item.object_scheme_url'
  )
  s-link-object-guid(
    :dialog='guidsDialog'
    :complexId = 'id'
    :objectId = 'objectId'
    @select='onSelectObjectGuid'
    @close='guidsDialog = false'
  )
</template>
<style scoped>
.objecttype {
  font-weight: 400;
  color: rgba(0, 0, 0, 0.54);
}
</style>
<script>
import http from '@/http'
import ModalEditor from '@/modules/editor/components/ModalEditor'
import { mapActions, mapGetters, mapState } from 'vuex'
import { GenplanModal } from '@/modules/genplan'

// Индексы вкладок, на которых нужно скрыть кнопки
// Сохранить/Отмена
const actionsHiddenTabs = []

export default {
  props: ['id', 'objectId'],

  components: {
    ModalEditor,
    GenplanModal
  },

  data: () => ({
    item: {},
    extGuids: [],
    avatar: null,
    scheme: null,
    editorOpened: false,
    guidsDialog: false,
    complexId: null,
    active: 0,
    genplan: {
      options: {
        minZoom: 0,
        url: null,
        width: 0,
        height: 0
      },
      opened: false,
      objects: []
    }
  }),

  created() {
    if (!Object.keys(this.complex).length) {
      this.fetchObjects()
    }
  },

  async mounted() {
    let { coordinatesPicker } = this.$refs
    this.ManagmentCompFetch()

    if (this.objectId) {
      try {
        this.item = (
          await this.fetchSingle({
            id: this.objectId
          })
        ).data
        this.extGuids = this.item.ext_guids
        coordinatesPicker.loadMap()

        // Модель для редактирования генплана
        if (this.objectId && this.item.complex.complex_settings) {
          const { genplan } = this.item.complex.complex_settings

          if (genplan) {
            this.genplan.options = {
              ...genplan,
              url: genplan.url + genplan.mask,
              url_night: genplan.url_night
                ? genplan.url_night + genplan.mask
                : null
            }
          } else {
            this.genplan.options = {}
          }

          const response = await http.get(`/complexes/objects/${this.objectId}/paths`)
          this.genplan.objects = response.data
        }
      } catch (e) {
        this.$root.showSnack('Ошибка загрузки объекта')
      }
    } else {
      coordinatesPicker.loadMap()
    }
  },

  methods: {
    async onSave() {
      let data = this.createFormData()

      try {
        if (this.objectId) {
          await this.update({
            id: this.objectId,
            data
          })
        } else {
          await this.create({ data })
        }

        this.$root.showSnack('Объект сохранен')
        this.back()
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    async fetchObjects() {
      try {
        await this.fetchList({
          config: {
            params: {
              complex_id: this.id
            }
          }
        })
      } catch (e) {
        this.$root.showSnack('Ошибка загрузки объектов')
        this.back()
      }
    },

    async fetchObjectExtGuids() {
      try {
        this.extGuids = (
          await http.get(`complexes/objects/${this.objectId}/link`)
        ).data
      } catch (e) {
        this.$root.showSnack('Ошибка загрузки объектов')
      }
    },

    onRemoveScheme() {
      this.item.object_scheme = null
    },

    onRemoveAvatar() {
      this.item.avatar = null
    },

    onGeographyChange({ address }) {
      this.$set(this.item, 'address', address)
    },

    createFormData() {
      let data = new FormData()

      this.item.complex_id = this.id

      Object.keys(this.item).forEach(key => {
        data.append(key, this.item[key])
      })

      return data
    },

    async onDeleteGuidLink(link) {
      if (!(await this.$confirm('Вы уверены?'))) return

      try {
        await this.destroyGuidLink(link)
        this.fetchObjectExtGuids()
      } catch (e) {
        this.$root.showSnack('Ошибка удаления')
      }
    },

    openLinkGuidDialog() {
      this.guidsDialog = true
    },

    async onSelectObjectGuid() {
      this.guidsDialog = false
      this.fetchObjectExtGuids()
    },

    async saveGenplan() {
      if (await this.$confirm('Сохранить изменения')) {
        let sections = this.genplan.objects
        try {
          await http.patch(`/complexes/objects/${this.objectId}/paths`, {
            sections
          })
          this.$root.showSnack('Генплан сохранен')
          this.genplan.opened = false
        } catch (e) {
          this.$root.showSnack('Ошибка сохранения генплана')
        }
      }
    },

    back() {
      this.$router.push({
        name: 'Complexes.Objects',
        params: { id: this.id }
      })
    },

    ...mapActions('objects/objects', [
      'fetchSingle',
      'fetchList',
      'update',
      'create',
      'destroyGuidLink',
      'linkGuid'
    ]),

    ...mapActions('objects/management_comp', {
      ManagmentCompFetch: 'fetchList'
    })
  },

  computed: {
    complex() {
      return this.complexById(this.id)
    },

    // Не будем показывать кноки Сохарнить/Отмена
    // на некоторых вкладках
    actionsShown() {
      return !actionsHiddenTabs.includes(this.active)
    },

    ...mapGetters('objects/objects', ['isLoading', 'complexById']),
    ...mapGetters('objects/management_comp', { managementCompList: 'list' }),
    ...mapState('objects/objects', ['objectsList'])
  }
}
</script>
